import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";

const JobSection = ({ section, slug, index }) => (
  <div className="mt-14 first:mt-0" data-testid={`career-section-${slug}-${index}`}>
    <h3 className="h-section text-xl sm:text-2xl text-black">{section.heading}</h3>
    {section.paragraphs?.length > 0 && (
      <div className="mt-6 space-y-5">
        {section.paragraphs.map((p, i) => (
          <p key={i} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{p}</p>
        ))}
      </div>
    )}
    {section.bullets?.length > 0 && (
      <ul className="mt-6 space-y-3">
        {section.bullets.map((b, i) => (
          <li key={i} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">
            {b}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default function Careers() {
  const { content } = useLang();
  const careers = content.careers;
  if (!careers) return null;

  return (
    <>
      <PageHero label={careers.title} image={IMAGES.careers} compact />
      <section className="bg-white" data-testid="careers-section">
        <div className="container-x pt-8 pb-20 md:pt-10 md:pb-28">
          {careers.jobs.map((job, ji) => (
            <FadeUp key={job.slug} className={`max-w-3xl ${ji ? "mt-28" : ""}`}>
              <div data-testid={`career-job-${job.slug}`}>
              <h2 data-testid={`career-job-title-${job.slug}`} className="h-display text-3xl sm:text-4xl text-black">{job.title}</h2>

              <div className="mt-10" data-testid={`career-framing-${job.slug}`}>
                <div>
                  <h3 className="h-section text-xl sm:text-2xl text-black">{job.framing.heading}</h3>
                  <dl className="mt-6 grid grid-cols-1 gap-x-10 gap-y-4 sm:grid-cols-2">
                    {job.framing.items.map((it, i) => (
                      <div key={i} className="flex flex-col gap-1">
                        <dt className="earmark text-[var(--ink-3)]">{it.label}</dt>
                        <dd className="text-sm md:text-[15px] text-black">{it.value}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </div>

              {job.sections.map((s, i) => <JobSection key={i} section={s} slug={job.slug} index={i} />)}
              </div>
            </FadeUp>
          ))}
        </div>
      </section>
    </>
  );
}
